export const nmfNavigation = [
  {
    title: 'Shipping',
    url: '',
  },
  {
    title: 'Intro',
    url: '',
  },
  {
    title: 'Survey',
    url: '',
  },
  {
    title: 'Customize',
    url: '',
  },
  {
    title: 'Done',
    url: '',
  },
];
